import { css, styled } from 'styled-components'
import { onLargeScreen, onMediumScreen } from 'mixtiles-web-common'
import { TOP_BAR_DESKTOP_HEIGHT } from 'elements/TopBar/consts'
import { Poster as HomePageVideoPoster } from 'pages/HomePage/Components/HomePageVideo/HomePageVideo.styles'
import {
  LARGE_SCREEN_HERO_HEIGHT,
  MEDIUM_SCREEN_HERO_HEIGHT,
  MOBILE_VIDEO_ASPECT_RATIO,
  SIDE_BY_SIDE_VIDEO_ASPECT_RATIO,
} from '../multiProductHomePage.consts'

export const Section = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: ${MOBILE_VIDEO_ASPECT_RATIO};
  overflow: hidden;

  ${onMediumScreen()} {
    /* Figma's height leaves the text room above what the video shows. Past Figma's 1920px frame the
       hero grows with the video instead of cropping its top and bottom, up to the screen below the top bar. */
    aspect-ratio: ${SIDE_BY_SIDE_VIDEO_ASPECT_RATIO};
    min-height: ${MEDIUM_SCREEN_HERO_HEIGHT}px;
    max-height: calc(100svh - ${TOP_BAR_DESKTOP_HEIGHT}px);
  }

  ${onLargeScreen()} {
    min-height: ${LARGE_SCREEN_HERO_HEIGHT}px;
  }
`

// HomePageVideo draws its video 2px taller than its box to hide a black edge; a poster as tall
// keeps the swap from poster to video from shifting the picture.
export const posterAsTallAsVideoStyles = css`
  ${HomePageVideoPoster} {
    height: calc(100% + 2px);
  }
`

export const heroVideoStyles = css`
  position: absolute;
  inset: 0;
  height: 100%;

  ${onMediumScreen()} {
    ${posterAsTallAsVideoStyles}
  }
`
